export const modalScreenClose = true;
export const modalScreenNotClose = false;
export const closeButtonDisable = false;
export const closeButtonEnable = true;

export interface CommonModalInterface {
  title: string;
  subHeading: string;
  subHeading2?: string;
  buttonText1: boolean; //button is not visable "Secondary medium"- [false]
  buttonText2: string;
  imageUrl: string;
  closeButton: boolean; //Close Icon right side of Popup remove- [false].
  disableClose: boolean; //Click out side screen the Popup will not close- [false].
}

export const changePasswordModalData = {
  title: "MODALS.CHANGE_PASSWORD.SUCCESS_TITLE",
  subHeading: "MODALS.CHANGE_PASSWORD.SUCCESS_SUBHEADING",
  buttonText1: false,
  buttonText2: "MODALS.CHANGE_PASSWORD.BACK_TO_PROFILE",
  imageUrl: "assets/images/shared/AdminResetModalSuccess.svg",
  closeButton: closeButtonEnable,
  disableClose: modalScreenNotClose,
};
export const changePasswordLeaveModal = {
  title: "MODALS.CHANGE_PASSWORD.LEAVE_TITLE",
  subHeading: "MODALS.CHANGE_PASSWORD.LEAVE_SUBHEADING",
  buttonText1: "MODALS.CHANGE_PASSWORD.STAY_ON_PAGE",
  buttonText2: "MODALS.CHANGE_PASSWORD.LEAVE_PAGE",
  imageUrl: "assets/images/shared/Illustration - Alert.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenClose,
};
export const changeSecretQuestionModalData = {
  title: "MODALS.CHANGE_SECRET_QUESTION.SUCCESS_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.CHANGE_PASSWORD.BACK_TO_PROFILE",
  imageUrl: "assets/images/shared/Illustration - Success.svg",
  closeButton: closeButtonEnable,
  disableClose: modalScreenNotClose,
};
export const contactDetailsSuccessModalData = {
  title: "MODALS.CONTACT_DETAILS.SUCCESS_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.CHANGE_PASSWORD.BACK_TO_PROFILE",
  imageUrl: "assets/images/shared/Illustration - Success.svg",
  closeButton: closeButtonEnable,
  disableClose: modalScreenNotClose,
};
export const firstTimeSuccessModalData = {
  title: "MODALS.FIRST_TIME_LOGIN.SUCCESS_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.FIRST_TIME_LOGIN.PROCEED_TO_DASHBOARD",
  imageUrl: "assets/images/shared/Illustration - Success.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenClose,
};
export const emergencyAlertModalData = {
  title: "MODALS.EMERGENCY_ALERT.SUCCESS_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.EMERGENCY_ALERT.BACK_TO_EMERGENCY_ALERT",
  imageUrl: "assets/images/shared/AdminResetModalSuccess.svg",
  closeButton: closeButtonEnable,
  disableClose: modalScreenNotClose,
};
export const concurrentLoginModalData = {
  title: "MODALS.CONCURRENT_LOGIN.TITLE",
  subHeading: "MODALS.CONCURRENT_LOGIN.SUBHEADING",
  subHeading2: "MODALS.CONCURRENT_LOGIN.SUBHEADING2",
  buttonText1: "MODALS.CONCURRENT_LOGIN.NO",
  buttonText2: "MODALS.CONCURRENT_LOGIN.YES",
  imageUrl: "assets/images/shared/Illustration - Alert.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenClose,
};
export const loginAlertModalData = {
  title: "MODALS.LOGIN_ALERT.SUCCESS_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.LOGIN_ALERT.BACK_TO_LOGIN_ALERT",
  imageUrl: "assets/images/shared/AdminResetModalSuccess.svg",
  closeButton: closeButtonEnable,
  disableClose: modalScreenNotClose,
};
export const alertHistoryModalData = {
  title: "MODALS.CONFIRMATION.ARE_YOU_SURE",
  subHeading: "MODALS.CONFIRMATION.ALERT_ARCHIVED_SUBHEADING",
  buttonText1: "MODALS.CONFIRMATION.NO_CANCEL",
  buttonText2: "MODALS.CONFIRMATION.YES_SURE",
  imageUrl: "assets/images/shared/Illustration - Alert.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenClose,
};
export const archivedEmergencyModalData = {
  title: "MODALS.EMERGENCY_ALERT.ARCHIVED_TITLE",
  subHeading: "MODALS.EMERGENCY_ALERT.ARCHIVED_SUBHEADING",
  buttonText1: false,
  buttonText2: "MODALS.EMERGENCY_ALERT.BACK_TO_EMERGENCY_ALERT",
  imageUrl: "assets/images/shared/AdminResetModalSuccess.svg",
  closeButton: closeButtonEnable,
  disableClose: modalScreenNotClose,
};
export const archivedSuccessModalData = {
  title: "MODALS.LOGIN_ALERT.ARCHIVED_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.LOGIN_ALERT.BACK_TO_LOGIN_ALERT",
  imageUrl: "assets/images/shared/AdminResetModalSuccess.svg",
  closeButton: closeButtonEnable,
  disableClose: modalScreenNotClose,
};
export const successUpdateModalData = {
  title: "MODALS.LOGIN_ALERT.UPDATED_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.LOGIN_ALERT.BACK_TO_LOGIN_ALERT",
  imageUrl: "assets/images/shared/AdminResetModalSuccess.svg",
  closeButton: closeButtonEnable,
  disableClose: modalScreenNotClose,
};
export const successEUpdatedModalData = {
  title: "MODALS.EMERGENCY_ALERT.UPDATED_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.EMERGENCY_ALERT.BACK_TO_EMERGENCY_ALERT",
  imageUrl: "assets/images/shared/AdminResetModalSuccess.svg",
  closeButton: closeButtonEnable,
  disableClose: modalScreenNotClose,
};
export const confirmationArchivedModalData = {
  title: "MODALS.CONFIRMATION.ARE_YOU_SURE",
  subHeading: "MODALS.CONFIRMATION.LOGIN_ARCHIVED_SUBHEADING",
  buttonText1: "MODALS.CONFIRMATION.NO_CANCEL",
  buttonText2: "MODALS.CONFIRMATION.YES_SURE",
  imageUrl: "assets/images/shared/Illustration - Alert.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenClose,
};
export const confirmationEventArchivedModalData = {
  title: "MODALS.CONFIRMATION.ARE_YOU_SURE",
  subHeading: "MODALS.CONFIRMATION.EVENT_ARCHIVED_SUBHEADING",
  buttonText1: "MODALS.CONFIRMATION.NO_CANCEL",
  buttonText2: "MODALS.CONFIRMATION.YES_SURE",
  imageUrl: "assets/images/shared/Illustration - Alert.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenClose,
};
export const confirmationCampaignArchivedModalData = {
  title: "MODALS.CONFIRMATION.ARE_YOU_SURE",
  subHeading: "MODALS.CONFIRMATION.CAMPAIGN_ARCHIVED_SUBHEADING",
  buttonText1: "MODALS.CONFIRMATION.NO_CANCEL",
  buttonText2: "MODALS.CONFIRMATION.YES_SURE",
  imageUrl: "assets/images/shared/Illustration - Alert.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenClose,
};
export const resetPasswordSuccessModalData = {
  title: "MODALS.RESET_PASSWORD.SUCCESS_TITLE",
  subHeading: "MODALS.RESET_PASSWORD.SUCCESS_SUBHEADING",
  buttonText1: false,
  buttonText2: "MODALS.RESET_PASSWORD.GO_TO_LOGIN",
  imageUrl: "assets/images/shared/Illustration - Success.svg",
  closeButton: closeButtonEnable,
  disableClose: modalScreenNotClose,
};

export const ieUserNotificationModalData = {
  title: "MODALS.IE_USER_NOTIFICATION.TITLE",
  subHeading: "MODALS.IE_USER_NOTIFICATION.SUBHEADING",
  buttonText1: false,
  buttonText2: false,
  imageUrl: "assets/images/shared/Illustration - Success.svg",
  closeButton: closeButtonEnable,
  disableClose: modalScreenNotClose,
};

export const createEventModalData = {
  title: "MODALS.EVENT_MANAGEMENT.CREATE_SUCCESS_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.EVENT_MANAGEMENT.BACK_TO_EVENT_MANAGEMENT",
  imageUrl: "assets/images/shared/Illustration - Success.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenNotClose,
};

export const updateEventModalData = {
  title: "MODALS.EVENT_MANAGEMENT.UPDATE_SUCCESS_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.EVENT_MANAGEMENT.BACK_TO_EVENT_MANAGEMENT",
  imageUrl: "assets/images/shared/Illustration - Success.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenNotClose,
};

export const createCrossSellSuccessModalData = {
  title: "MODALS.CROSS_SELL.CREATE_SUCCESS_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.CROSS_SELL.BACK_TO_CROSS_SELL",
  imageUrl: "assets/images/shared/Illustration - Success.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenNotClose,
};

export const createCrossSellLeaveModal = {
  title: "MODALS.CHANGE_PASSWORD.LEAVE_TITLE",
  subHeading: "MODALS.CHANGE_PASSWORD.LEAVE_SUBHEADING",
  buttonText1: "MODALS.CHANGE_PASSWORD.STAY_ON_PAGE",
  buttonText2: "MODALS.CHANGE_PASSWORD.LEAVE_PAGE",
  imageUrl: "assets/images/shared/Illustration - Alert.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenClose,
};

export const updateCrossSellSuccessModalData = {
  title: "MODALS.CROSS_SELL.UPDATE_SUCCESS_TITLE",
  subHeading: false,
  buttonText1: false,
  buttonText2: "MODALS.CROSS_SELL.BACK_TO_CROSS_SELL",
  imageUrl: "assets/images/shared/Illustration - Success.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenNotClose,
};

export const updateCrossSellLeaveModal = {
  title: "MODALS.CONFIRMATION.ARE_YOU_SURE",
  subHeading: "MODALS.CONFIRMATION.CROSS_SELL_ARCHIVED_SUBHEADING",
  buttonText1: "MODALS.CONFIRMATION.NO_CANCEL",
  buttonText2: "MODALS.CONFIRMATION.YES_SURE",
  imageUrl: "assets/images/shared/Illustration - Alert.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenClose,
};

export const expiringPasswordModalData = {
  title: "MODALS.EXPIRING_PASSWORD.TITLE",
  subHeading: "MODALS.EXPIRING_PASSWORD.SUBHEADING",
  subHeading2: "",
  buttonText1: "MODALS.COMMON.NO",
  buttonText2: "MODALS.COMMON.YES",
  imageUrl: "assets/images/shared/Illustration - Alert.svg",
  closeButton: closeButtonDisable,
  disableClose: modalScreenClose,
};
